var tables = {
  interactiveTable: {
    table: {
      variant: 'tables.table',
      fontSize: 'sm',
      lineHeight: '1.5',
      tableLayout: 'auto',
      borderCollapse: 'separate'
    },
    body: {
      fontWeight: 'light',
      '& tr td:first-of-type': {
        ml: '3px'
      },
      '& tr:nth-of-type(2n + 1)': {
        td: {
          backgroundColor: 'neutral.lighter',
          boxShadow: 'unset'
        }
      },
      '& .csg-rc-table-expanded-row .csg-rc-table-cell': {
        backgroundColor: 'white',
        boxShadow: '0px 0px 4px #bfbfbf'
      },
      '.csg-rc-table-placeholder .csg-rc-table-expanded-row-fixed': {
        position: 'unset'
      },
      '.csg-tui-anchor': {
        display: 'block'
      }
    },
    cell: {
      padding: '.5rem',
      verticalAlign: 'middle'
    },
    head: {
      color: 'primary',
      fontSize: 'sm',
      lineHeight: '1.5',
      whiteSpace: 'nowrap',
      'tr th .react-resizable-handle': {
        backgroundColor: 'primary',
        backgroundImage: 'unset',
        height: '100%',
        width: '4px',
        cursor: 'ew-resize',
        opacity: '0',
        '&:hover': {
          opacity: '1'
        }
      },
      '.react-resizable:hover .react-resizable-handle': {
        backgroundColor: 'primary',
        backgroundImage: 'unset',
        height: '100%',
        width: '4px',
        cursor: 'ew-resize',
        opacity: '1'
      },
      '.csg-tui-th[colspan], .csg-tui-th[rowspan],': {
        verticalAlign: 'bottom'
      },
      '.csg-rc-table-cell[colspan="2"]': {
        color: 'black',
        textAlign: 'center'
      },
      '.csg-rc-table-cell .csg-tui-button:focus': {
        textShadow: 'unset'
      }
    },
    headCell: {
      padding: '.5rem',
      borderBottom: 'unset',
      bg: 'neutral.light'
    },
    row: {
      '&:not(.csg-rc-table-placeholder):hover .csg-tui-td': {
        bg: 'primary.light'
      }
    },
    '.csg-rc-table-body, .csg-rc-table-content': {
      color: 'mediumGray'
    }
  },
  'interactive-table': {
    table: {
      variant: 'tables.table',
      fontSize: 'sm',
      lineHeight: '1.5',
      tableLayout: 'auto',
      borderCollapse: 'separate',
      '& .csg-rc-table-thead': {
        color: 'primary',
        fontSize: 'sm',
        lineHeight: '1.5',
        whiteSpace: 'nowrap',
        th: {
          padding: '.5rem',
          borderBottom: 'unset',
          bg: 'neutral.light',
          verticalAlign: 'middle'
        },
        'tr th': {
          ':hover .react-resizable-handle': {
            opacity: '1'
          }
        },
        '.react-resizable-handle': {
          backgroundColor: 'primary',
          backgroundImage: 'unset',
          height: '100%',
          width: '4px',
          cursor: 'ew-resize',
          opacity: '0'
        },
        '.csg-rc-table-cell[colspan], .csg-rc-table-cell[rowspan]': {
          verticalAlign: 'bottom'
        },
        '.csg-rc-table-cell[colspan="2"]': {
          color: 'black',
          textAlign: 'center'
        }
      },
      '& .csg-rc-table-tbody': {
        fontWeight: 'light',
        tr: {
          td: {
            padding: '.5rem',
            verticalAlign: 'middle'
          },
          ':nth-of-type(2n + 1)': {
            td: {
              backgroundColor: 'neutral.lighter',
              boxShadow: 'unset'
            }
          },
          ':not(.csg-rc-table-placeholder):hover td': {
            bg: 'primary.light'
          }
        },
        '.csg-rc-table-expanded-row .csg-rc-table-cell': {
          backgroundColor: 'white',
          boxShadow: '0px 0px 4px #bfbfbf'
        },
        '.csg-rc-table-placeholder .csg-rc-table-expanded-row-fixed': {
          position: 'unset'
        },
        '.csg-tui-anchor': {
          display: 'block'
        }
      }
    }
  },
  'simple-table': {
    table: {
      variant: 'tables.table',
      fontSize: 'sm'
    },
    head: {
      fontWeight: 'body',
      borderBottom: 'neutral.medium',
      '& tr': {
        'th:not(:first-of-type)': {
          pl: 'xxl'
        },
        'th:first-of-type': {
          pl: 'xs'
        },
        'th:last-of-type': {
          pr: 'xs'
        }
      }
    },
    headCell: {
      fontWeight: 'inherit',
      borderColor: 'neutral.medium',
      bg: 'neutral.light'
    },
    row: {
      height: '2em',
      borderBottom: 'neutral.light',
      '& td:not(:first-of-type)': {
        pl: 'xxl'
      },
      '& td:first-of-type': {
        pl: 'xs'
      },
      '& td:last-of-type': {
        pr: 'xs'
      }
    }
  },
  'first-column-ellipsis-only': {
    table: {
      variant: 'tables.table',
      fontSize: 'sm'
    },
    head: {
      fontWeight: 'body',
      borderBottom: 'neutral.medium',
      '& tr': {
        'th:not(:first-of-type)': {
          pl: 'xxl'
        },
        'th:first-of-type': {
          pl: 'xs'
        },
        'th:last-of-type': {
          pr: 'xs'
        }
      }
    },
    headCell: {
      fontWeight: 'inherit',
      borderColor: 'neutral.medium',
      bg: 'neutral.light'
    },
    row: {
      height: '2em',
      borderBottom: 'neutral.light',
      '& td:not(:first-of-type)': {
        pl: 'xxl'
      },
      '& td:first-of-type': {
        pl: 'xs'
      },
      '& td:last-of-type': {
        pr: 'xs'
      },
      'td:not(:first-of-type)': {
        whiteSpace: 'nowrap'
      }
    }
  }
};

export { tables };
//# sourceMappingURL=tables.esm.js.map
